import { render, staticRenderFns } from "./Layout.vue?vue&type=template&id=a0e3be6a&scoped=true"
import script from "./Layout.vue?vue&type=script&lang=ts"
export * from "./Layout.vue?vue&type=script&lang=ts"
import style0 from "./Layout.vue?vue&type=style&index=0&id=a0e3be6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../qraved-ordering-backoffice/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0e3be6a",
  null
  
)

export default component.exports